import { takeLatest } from 'redux-saga/effects';
import {
  deleteVideoEffect,
  fetchDownloadVideoEffect,
  generateThumbnailRequestEffect,
  markAsStartVideoEffect,
  markVideoFeaturedEffect,
  pullThumbnailRequestEffect,
  reportVideoEffect,
  unmarkAsStartVideoEffect,
  unMarkVideoFeaturedEffect,
} from './effects';
import {
  CREATE_THUMBNAIL_REQUEST,
  DELETE_VIDEO,
  FETCH_DOWNLOAD_VIDEO_REQUEST,
  MARK_AS_START_VIDEO,
  PULL_THUMBNAIL_REQUEST,
  REPORT_VIDEO,
  UNMARK_AS_START_VIDEO,
  VIDEO_MARK_FEATURED,
  VIDEO_UNMARK_FEATURED,
} from 'common/actions';
import { markHomeStartVideoEffect, unmarkHomeStartVideoEffect } from 'components/mark-unmark-start-home-video/effects';
import { MARK_HOME_START_VIDEO, UNMARK_HOME_START_VIDEO } from 'components/mark-unmark-start-home-video/actions';

export const videosSaga = function* () {
  yield takeLatest(DELETE_VIDEO, deleteVideoEffect);

  yield takeLatest(VIDEO_MARK_FEATURED, markVideoFeaturedEffect);
  yield takeLatest(VIDEO_UNMARK_FEATURED, unMarkVideoFeaturedEffect);

  yield takeLatest(MARK_AS_START_VIDEO, markAsStartVideoEffect);
  yield takeLatest(UNMARK_AS_START_VIDEO, unmarkAsStartVideoEffect);

  yield takeLatest(FETCH_DOWNLOAD_VIDEO_REQUEST, fetchDownloadVideoEffect);

  yield takeLatest(CREATE_THUMBNAIL_REQUEST, generateThumbnailRequestEffect);
  yield takeLatest(PULL_THUMBNAIL_REQUEST, pullThumbnailRequestEffect);

  yield takeLatest(REPORT_VIDEO, reportVideoEffect);

  yield takeLatest(MARK_HOME_START_VIDEO, markHomeStartVideoEffect);
  yield takeLatest(UNMARK_HOME_START_VIDEO, unmarkHomeStartVideoEffect);
};
